/**
 * @generated SignedSource<<45b7b6c0f0bbf826484f588e65dfafd3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_item$data = {
  readonly isSold: boolean | null;
  readonly isUnpurchasable: boolean | null;
  readonly saveSearchData: {
    readonly name: string | null;
    readonly page: string | null;
  } | null;
  readonly skus?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"useDisplayInfo_multiskus">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_item" | "PdpSharedMakeOfferButton_item" | "PdpSharedPurchaseButton_item" | "PdpSharedShoppingButtons_item">;
  readonly " $fragmentType": "PdpRespSidebarButtons_item";
};
export type PdpRespSidebarButtons_item$key = {
  readonly " $data"?: PdpRespSidebarButtons_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnpurchasable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SaveSearchDataType",
      "kind": "LinkedField",
      "name": "saveSearchData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "page",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item"
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSkuType",
          "kind": "LinkedField",
          "name": "skus",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useDisplayInfo_multiskus"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShoppingButtons_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "20c3d5147b2d86b47cf3fc05ce3bce35";

export default node;
